import React from 'react';
import Toolbar from './Toolbar/Toolbar';
import Carrusel from './Carrusel/Carrusel';
import classes from './Header.module.css';

const Header = props => {
  const { menuIconClicked, openLogin } = props;
  const isMobile = window.innerWidth <= 800;

  return (
    <header className={classes.header} id="startHeader">
      <Toolbar menuIconClicked={menuIconClicked} openLogin={openLogin} />
      {isMobile ? (
        <div className={classes.landingMobile}>
          <h1 className={classes.tituloLandingMobile}>
            VeDi evoluciona,
            <br />
            tu experiencia también
          </h1>
          <p className={classes.textoLandingMobile}>
            Plataforma tecnológica que permite acceder de forma <strong>ágil</strong> y{' '}
            <strong>simple</strong> a los diferentes trámites y servicios web del municipio,
            centralizando todas las{' '}
            <strong>
              funciones, trámites, servicios, software, aplicaciones y comunicaciones,
            </strong>{' '}
            en un entorno que genera una experiencia positiva para los usuarios.
          </p>
        </div>
      ) : (
        <Carrusel></Carrusel>
      )}
    </header>
  );
};

export default Header;
